import { api } from "@/lib/apiClient";
// Legacy list endpoints return arrays, with optional X-Total-Count pagination metadata.
export async function allPages(path) {
  const first = await api.get(path);
  const result = [...first.data];
  const total = Number(first.headers?.["x-total-count"] ?? result.length);
  const size = first.data.length;
  if (!size) return result;
  for (let page=2; result.length < total; page++) {
    const { data } = await api.get(path, { params: { page, page_size: size } });
    if (!data.length) break;
    result.push(...data);
  }
  return result;
}

export async function allItems(path) {
  const first = await api.get(path);
  const items = [...first.data.items], size = first.data.page_size || items.length;
  if (!size) return items;
  for (let page=2; items.length < first.data.total; page++) {
    const { data } = await api.get(path, { params: { page, page_size: size } });
    if (!data.items.length) break;
    items.push(...data.items);
  }
  return items;
}
